import { Box } from "@mui/material";
import React from "react";

const LayerViewPrototype = ({
  shapes,
  styles,
}: {
  shapes: any; // TODO: Type
  styles: any[]; // TODO: Type
}) => {
  //convert from numbers in srray to rgb
  const arrToRgb = (arr: number[]): string => {
    return `rgba(${arr[0] * 255}, ${arr[1] * 255}, ${arr[2] * 255}, ${arr[3]})`;
  };

  const point = styles.find((item) => item.symbolizer === "point");
  let shape;
  if (point) {
    if (point.params["font-marker"]) {
      shape = shapes.find(
        (item: any) => item.value === point.params["font-marker"].name // TODO: Type
      );
    } else {
      shape = {
        value: "",
        icon: <></>,
        customizeIcon: () => {
          return <></>;
        },
      };
    }
    const color = arrToRgb(point.params.stroke);
    const psize =
      point.symbolizer === "point" && point.params.size
        ? point.params.size + 8
        : 0;
    shape = shape?.customizeIcon(color, psize + "px");
  }

  const line = styles.find((item) => item.symbolizer === "line");
  const polygon = styles.find((item) => item.symbolizer === "polygon");

  const size = point?.symbolizer === "point" ? point.params.size : 0;
  if (polygon) {
    const width =
      line?.symbolizer === "line" ? line?.params["stroke-width"] : 0;
    const view = (
      <Box
        width={"120px"}
        height={"120px"}
        position={"relative"}
        display={"flex"}
        justifyContent={"space-between"}
        overflow="hidden"
      >
        <Box position={"absolute"} top={0} left={0} zIndex={1}>
          {shape}
        </Box>
        <Box position={"absolute"} bottom={0} left={0} zIndex={1}>
          {shape}
        </Box>
        <Box position={"absolute"} top={0} right={0} zIndex={1}>
          {shape}
        </Box>
        <Box position={"absolute"} bottom={0} right={0} zIndex={1}>
          {shape}
        </Box>
        {line ? (
          <Box
            width={"calc(100% - " + (size + width) + "px)"}
            height={"calc(120px - " + (size + width + 4) + "px)"}
            marginTop={size / 2 - width / 2 + "px"}
            marginLeft={size / 2 - width / 2 + "px"}
            sx={{
              border: width + "px solid",
              borderColor: line.params.stroke
                ? arrToRgb(line.params.stroke)
                : "",
              backgroundColor:
                polygon.symbolizer === "polygon"
                  ? arrToRgb(polygon.params.fill)
                  : "black",
              zIndex: 0,
            }}
          ></Box>
        ) : (
          <Box
            width={"calc(100% - " + (size + width) + "px)"}
            height={"calc(120px - " + (size + width + 4) + "px)"}
            marginTop={size / 2 - width / 2 + "px"}
            marginLeft={size / 2 - width / 2 + "px"}
            sx={{
              backgroundColor:
                polygon.symbolizer === "polygon"
                  ? arrToRgb(polygon.params.fill)
                  : "black",
              zIndex: 0,
            }}
          ></Box>
        )}
      </Box>
    );
    return view;
  } else if (line && !polygon) {
    if (line.symbolizer !== "line") return;
    const width = line?.params["stroke-width"];
    const view = (
      <Box
        width={"120px"}
        minHeight={"8px"}
        position={"relative"}
        display={"flex"}
        justifyContent={"space-between"}
        overflow="hidden"
      >
        {shape}
        <Box
          width={"calc(100% - " + size + "px)"}
          left={size / 2 + "px"}
          position="absolute"
          top={"calc(50% - " + width / 2 + "px)"}
          height={width + "px"}
          sx={{
            backgroundColor: line.params.stroke
              ? arrToRgb(line.params.stroke)
              : "",
            zIndex: 0,
          }}
        ></Box>
        {shape}
      </Box>
    );
    return view;
  } else if (point) {
    return shape;
  }
};

export default LayerViewPrototype;
